import React from "react";
import { Link } from "react-router-dom";
import { Dropdown, Menu, Icon } from "antd";

const VideosList = ({ vimeoId, curso }) => {
    const buildMenu = () => {
        const nomeCurso = curso.replace(/[&\/\\#,+()$~%.'":*?!<>{}\s]/g, "-").toLowerCase();

        var menuOptions = JSON.parse(vimeoId).map((video, index) => (
            <Menu.Item>
                <a href={`/curso/${nomeCurso}/vconf/${video}/player-video-meets`} target="_blank">
                    Vídeo {index + 1}
                </a>
            </Menu.Item>
        ));

        return <Menu>{menuOptions}</Menu>;
    };

    return (
        <Dropdown overlay={buildMenu} placement="bottomLeft">
            <Link to="#" className="opcao-player-videos" title="Vídeos">
                <Icon type="video-camera" />
            </Link>
        </Dropdown>
    );
};

export default VideosList;
